import fp from 'lodash/fp';
import { put, all, call, takeLatest } from 'redux-saga/effects';
import { environment } from '@factorin/container.macro';
import { system } from '@factorin/rest';

import { apiCall } from 'Modules/core/api';
import { i18nActionTypes } from 'Modules/core/i18n';
import { messagingActions } from 'Modules/core/messaging';

import { environmentActions, environmentActionTypes } from './actions';


export const mapDictFilters = fp.keyBy('Code');
export const mapDictNodes = fp.keyBy('DltKey');

export function* tryGetEnvironmentPart(api, setter) {
    const data = yield apiCall(api);
    yield put(environmentActions.setEnvironment(setter(data)));
}

function* getSystemInfo() {
    try {
        const systemInfo = yield apiCall(system.info);
        yield put(environmentActions.setEnvironment({ systemInfo }));
    } catch (error) {
        yield put(messagingActions.showNotification({
            content: {
                key: 'environment.systemInfoError',
                values: {
                    error,
                },
            },
        }));
    }
}

function* initializeSaga() {
    try {
        const [sequential, parallel] = fp.partition(fp.isArray, environment.initializationSagas);

        const sequientialSagasWithOrder = fp.pipe(
            fp.sortBy(fp.get(1)),
            fp.map(fp.first),
        )(sequential);

        for (let index = 0; index < sequientialSagasWithOrder.length; index++) {
            const result = yield call(sequientialSagasWithOrder[index]);
            if (result === null)
                return;
        }

        yield all(fp.map(call, parallel));
        yield put(environmentActions.setEnvironment({ initialized: true }));
    } catch (error) {
        yield put(environmentActions.setEnvironment({ error: { message: `${error}` } }));
    }
}

function* languageChangedSaga() {
    yield all(fp.map(call, environment.changeLanguageSagas));
}

export const sagas = [
    takeLatest(environmentActionTypes.INITIALIZE, initializeSaga),
    takeLatest(i18nActionTypes.LANGUAGE_CHANGED, languageChangedSaga),
];

export const initializationSagas = [
    getSystemInfo,
];
